import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_RTL } from 'constants/ThemeConstant';
import { API_BASE_URL as API_BASE_URL_LAZY } from 'constants/ApiConstant'

export const APP_NAME = 'PMS';
export const API_BASE_URL = API_BASE_URL_LAZY
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: localStorage.getItem('locale') || 'ar',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: localStorage.getItem('direction') || DIR_RTL
};
